import React, { Suspense } from 'react';

const LazyEditor = React.lazy(() => import('./Editor'));
const LazyAnalytics = React.lazy(() => import('./Analytics'));

export const Editor = () => {
  return (
    <>
      <Suspense fallback={null}>
        <LazyAnalytics />
      </Suspense>
      <Suspense
        fallback={
          <div className="h-[250px] outline-none py-[15px] px-2.5 resize-none text-ellipsis overflow-auto">
            Editor Loading...
          </div>
        }
      >
        <LazyEditor />
      </Suspense>
    </>
  );
};
